import React from 'react';
import '../styles/Footer.css';
import footerBg from '../assets/footerimg3.jpg';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer
      className="footer-section"
      style={{
        backgroundImage: `url(${footerBg})`
      }}
    >
      <div className="footer-overlay">

        <div className="footer-column">
          <h4>COMPANY</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/servicepg">Our Services</a></li>
            <li><a href="/contactpg">Careers</a></li>
            <li><a href="/contactpg">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>QUICK LINKS</h4>
          <ul>
            <li><a href="/servicepg">Electrical</a></li>
            <li><a href="/mechpg">Mechanical</a></li>
            <li><a href="/civilpg">Civil</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>SERVICES</h4>
          <ul>
            <li><a href="/services/service1">Engineering Design</a></li>
            <li><a href="/services/service2">Testing And Commissioning</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>CONTACT</h4>
          <ul>
            <li>
              <FaPhoneAlt className="footer-icon" />
              <a href="tel:+918925188802">+91 8925188802</a>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <a href="mailto:services@apexcelindia.com">
                services@apexcelindia.com
              </a>
            </li>
          </ul>
        </div>

      </div>
    </footer>
  );
};

export default Footer;